export const WHATSAPP_CHART_METRICS = [
  { id: 'messages_sent', label: 'Sent', color: '#1976d2' },
  { id: 'messages_delivered', label: 'Delivered', color: '#00a884' },
  { id: 'messages_read', label: 'Read', color: '#9c27b0' },
  { id: 'messages_failed', label: 'Failed', color: '#64748b' },
  { id: 'cta_clicks_total', label: 'CTA clicks', color: '#ed6c02' },
];

export const WHATSAPP_DEFAULT_METRIC_IDS = [
  'messages_sent',
  'messages_delivered',
  'messages_read',
];

const BY_ID = Object.fromEntries(WHATSAPP_CHART_METRICS.map((metric) => [metric.id, metric]));

export const METRIC_ALIASES = {
  messages_sent: ['messages_sent', 'sent', 'sent_count', 'message_sent'],
  messages_delivered: ['messages_delivered', 'delivered', 'delivered_count', 'message_delivered'],
  messages_read: ['messages_read', 'read', 'read_count', 'message_read'],
  messages_failed: ['messages_failed', 'failed', 'failed_count', 'message_failed'],
  cta_clicks_total: ['cta_clicks_total', 'cta_clicks', 'button_clicks', 'cta_count'],
};

export function findWhatsappMetric(metricId) {
  if (!metricId) return null;
  if (BY_ID[metricId]) return BY_ID[metricId];
  const normalized = String(metricId).toLowerCase().trim();
  for (const [canonicalId, aliases] of Object.entries(METRIC_ALIASES)) {
    if (aliases.includes(normalized)) {
      return BY_ID[canonicalId];
    }
  }
  return null;
}

export function decorateChartSeries(series = []) {
  return series.map((item, index) => {
    const known = findWhatsappMetric(item.id) || BY_ID[item.id];
    return {
      id: item.id || `series-${index}`,
      label: known?.label || item.label || item.id || 'Value',
      color: item.color || known?.color,
      data: (item.data || []).map((value) => Number(value) || 0),
    };
  });
}

export function defaultVisibleMetricIds(series = []) {
  const ids = series.map((item) => item.id);
  const preferred = ids.filter((id) => WHATSAPP_DEFAULT_METRIC_IDS.includes(id));
  return preferred.length ? preferred : ids;
}
